// Mirror of the pdf generator's cleanupScripts() (PdfGenerator.java) so a
// bundle-supplied document script travels compacted instead of cluttering
// the submission with source comments and indentation. Same four passes in
// the same order — the generator runs its own cleanupScripts() over the
// final script regardless, so applying this here never changes the PDF, it
// only shrinks what goes over the wire and into the stored bundle.
//
// Kept byte-faithful to the Java on purpose (including its quirks — e.g. a
// mid-line `//` preceded by whitespace eats the rest of the line, while
// `https://` survives because `:` precedes the slashes). Do not "improve"
// one side without the other.
export default function cleanupPdfScript(scripts) {
  return scripts
    .replace(/\r\n?/g, "\n") // the generator's normalizeNewlines(): a CR would
    // defeat the comment regex below (JS "." refuses to match "\r"), folding
    // nothing instead of the comment — template literals arrive LF-normalized
    // by spec, so this is insurance for any other source of script text
    .replace(/(?:(?:^[ \t]*)|(?:[ \t]+))\/\/.*\n/gm, "") // remove comment lines
    .replace(/\s+/g, " ") // collapse whitespace runs to a single space
    .replace(/\{ /g, "{") // remove space after "{"
    .replace(/ \}/g, "}"); // remove space before "}"
}
